import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";

//MUI Components
import { useTheme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import Typography from "@material-ui/core/Typography";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";

export default function Sites() {
	const theme = useTheme();
	const [rows, setRows] = useState([]);
	const [sortModel, setSortModel] = useState([
		{
			field: "site",
			sort: "asc",
		},
	]);
	const [loading, setLoading] = useState(true);

	const fetchRows = async () => {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/menus`);
		const data = await res.json();
		return data;
	};

	useEffect(() => {
		const getRows = async () => {
			let rowsFromServer = await fetchRows();
			setRows(rowsFromServer.data);
			setLoading(false);
		};
		getRows();
	}, []);

	function getSiteName(params) {
		return params.row.site.name;
	}

	const columns = useMemo(
		() => [
			{ field: "_id", headerName: "ID", hide: true, width: 225 },
			{
				field: "site",
				headerName: "Site",
				valueGetter: getSiteName,
				renderCell: (params) => {
					return (
						<React.Fragment>
							<IconButton
								component={Link}
								to={`/${process.env.REACT_APP_ADMIN_URL}/menus/${params.row._id}`}
								style={{ marginRight: ".5rem" }}
								aria-label="edit"
							>
								<EditIcon />
							</IconButton>
							<Link
								to={`/${params.row.site.slug}`}
								target="_blank"
								style={{ color: theme.palette.primary.main }}
							>
								{params.value}
							</Link>
						</React.Fragment>
					);
				},
				width: 500,
			},
		],
		[theme.palette.primary.main]
	);

	const useStyles = makeStyles({
		datagrid: {
			backgroundColor: "white",
			//Remove outlines when clicking a cell in the datagrid
			"&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
				outline: 0,
			},
			//Remove outlines when clicking a column header
			"&.MuiDataGrid-root .MuiDataGrid-colCell:focus": {
				outline: 0,
			},
		},
	});

	const classes = useStyles();

	if (loading) {
		return "Loading...";
	}

	return (
		<>
			<div
				style={{ display: "flex", alignItems: "center", marginBottom: "1rem" }}
			>
				<Typography component="h1" variant="h4">
					Menus
				</Typography>
			</div>
			<DataGrid
				disableSelectionOnClick
				className={classes.datagrid}
				getRowId={(row) => row._id}
				autoHeight
				rows={rows}
				columns={columns}
				sortModel={sortModel}
				onSortModelChange={(model) => {
					setSortModel(model);
				}}
			/>
		</>
	);
}
